<template>
  <footer id="footer"><!--Footer-->
		<div class="footer-top">
			<div class="container">
				<div class="row">
					<div >
						<div class="companyinfo">
							<h2>Usinagem Saraiva</h2>
							<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit,sed do eiusmod tempor</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="footer-widget">
			<div class="container">
				<div class="row">
					<div class="col-sm-6" style="text-align: left">
						<h2 class="title text-center">Contato</h2>
						<address>
						<p>Endereço: Avenida Benedito Alves Delfino, N° 1440 - Marilia- SP</p>
						<p>Telefone: (14) 3415-2817</p>
						<p>Whatsapp: (14) 98134-8198</p>
						<p>Email: usinagemsaraiva@gmail.com</p>
						</address>
					</div>
					<div class="col-sm-1 middle-border"></div>
					<div class="col-sm-5">
						<div class="social-networks">
							<h2 class="title text-center">Midias Sociais</h2>
						<ul>
							<li>
								<a href="https://www.facebook.com/Usinagem-Saraiva-240332769385228/?ref=bookmarks "><i class="fab fa-facebook faceIcon"></i></a>
							</li>
							<li>
								<a href="https://www.instagram.com/usinagemsaraiva/?hl=pt-br"><i class="fab fa-instagram faceIcon"></i></a>
							</li>
							<li>
								<a href="https://www.linkedin.com/company/usinagem-saraiva/about/?viewAsMember=true"><i class="fab fa-linkedin faceIcon"></i></a>
							</li>
							<!-- <li>
								<a href="#"><i class="fab fa-youtube"></i></a>
							</li> -->
						</ul>
						</div>
					</div>					
				</div>
			</div>
		</div>
		
		<div class="footer-bottom">
			<div class="container">
				<div class="row">
					<p class="pull-left">Copyright © 2018 Usinagem Saraiva. All rights reserved.</p>
					<p class="pull-right">Designed by <span><a target="_blank" href="http://www.themeum.com">Themeum</a></span></p>
				</div>
			</div>
		</div>

		
		
	</footer><!--/Footer-->
</template>
<script>
export default {
  name: 'Footer'
}
</script>
<style>
.middle-border {
    min-height: 140px;
    margin-top: 10px;
    border-left: 2px solid #b7b7b7;
}

.faceIcon{
	font-size: 50px;
	margin-top: 20px
}
</style>
